const ROOM_STATUS_COLORS = {
  DIRTY: '#E74646',
  CLEAN: '#FFE569',
  READY: '#3dcf89',
  OOO: '#331D2C',
  FOC: '#FFABAB',
  BOOKED: '#357456',
  AVAILABLE: '#fff'
}

const ROOM_TAG_ICONS = {
  OOO: 'mci_ooo_tag_icon',
  OOS: 'mci_oos_tag_icon',
  DIFF: 'mci_warning_tag_icon',
  AVAILABLE_ROOM: 'mci_room_available_tag_icon',
  ARRIVE: 'mci_plane_arrive_tag_icon',
  DEPART: 'mci_plane_depart_tag_icon',
  IN_HOUSE: 'mci_in_house_tag_icon',
  LONG_STAY: 'mci_calendar_full_tag_icon',
  SHORT_STAY: 'mci_calendar_tag_icon',
  MISSION_WARN_COMMENT_MESS: 'mci_star_tag_icon',
  LOCK: 'mci_lock_tag_icon'
}

const ROOM_STATUS_VALUE = {
  DIRTY: 1,
  CLEAN: 2,
  READY: 4
}

const ROOM_BOOKING_TYPE_VALUE = {
  VACANT: 0,
  OCCUPIED: 1
}

const BOOKING_STATUS = {
  DEFINITE: 1,
  TENTATIVE: 2,
  WAITING: 3
}

const BOOKING_ROOM_STATUS = {
  EMPTY: 0, // = AVAILABLE
  BOOKED: 1,
  IN_HOUSE: 2,
  CANCELED: 3,
  CHECK_OUT: 4
}

export {
  ROOM_STATUS_COLORS,
  ROOM_TAG_ICONS,
  ROOM_STATUS_VALUE,
  ROOM_BOOKING_TYPE_VALUE,
  BOOKING_STATUS,
  BOOKING_ROOM_STATUS
}

// export default {
//   ROOM_STATUS_COLORS
// }
